import React, { useState } from "react";
import AttendanceNonTeachingStaff from "./AttendanceNonTeachingStaff.jsx";
import TeacherAttendance from "../Teacher/TeacherAttendance.jsx";
import colors from "../Constant/colors.js";

const StaffAttendance = () => {
  const [selectedForm, setSelectedForm] = useState("teacher");

  const activeBtn = {
    background: colors.gradientPrimary,
    color: "white",
    padding: "10px 24px",
    fontWeight: "600",
    borderRadius: "8px",
    border: "none",
    fontSize: "14px",
  };

  const inactiveBtn = {
    background: "#E5E7EB",
    color: "black",
    padding: "10px 24px",
    fontWeight: "600",
    borderRadius: "8px",
    border: "1px solid #d1d5db",
    fontSize: "14px",
  };

  return (
    <div className="max-w-6xl mx-auto p-8" style={{ fontSize: "14px" }}>
      <div className="bg-white shadow-lg rounded-xl p-8 border border-gray-200">
        {/* TABS */}
        <div className="flex justify-center mb-10 gap-6">
          <button
            style={selectedForm === "teacher" ? activeBtn : inactiveBtn}
            onClick={() => setSelectedForm("teacher")}
          >
            Teacher Attendance
          </button>

          <button
            style={selectedForm === "nonTeaching" ? activeBtn : inactiveBtn}
            onClick={() => setSelectedForm("nonTeaching")}
          >
            Non-Teaching Staff Attendance
          </button>
        </div>

        {/* FORMS */}
        {selectedForm === "teacher" && <TeacherAttendance />}
        {selectedForm === "nonTeaching" && <AttendanceNonTeachingStaff />}
      </div>
    </div>
  );
};

export default StaffAttendance;
